import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { CsrfService } from '../services/csrf.service';
import { setForcePasswordChangeFlag } from '../util/auth/helpers';
import { CLAVE_CARA_GUARDADA, CLAVE_CARA_SESION } from '../services/suite-shell.logic';

@Injectable()
export class AuthService {

  constructor(
    private _http: HttpClient,
    private _jwtHelperService: JwtHelperService,
    private _cookieService: CookieService,
    private _csrfService: CsrfService
  ) {}

  async login({email, password}) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    const response: any = await this._http.post<any>(
      `${environment.apiUrl}/common/auth/login`, { email: normalizedEmail, password}).pipe(
       	map((response: Response) => {
        if (response['result'] && response['result']['token']) {
          localStorage.setItem('access_token', response['result']['token']);
          setForcePasswordChangeFlag(!!response['result']['forcepasswordchange']);
        }
        return response;
    })).toPromise();

    if (response && response['result'] && response['result']['token']) {
      try {
        await this._csrfService.fetchCsrfToken();
      } catch (error) {
        console.error('Failed to fetch CSRF token:', error);
      }
    }

    return response;
  }

  async oauthLogin(provider: string, providerId: string, email: string) {
    const response: any = await this._http.post<any>(
      `${environment.apiUrl}/common/auth/oauth-login`,
      { provider, provider_id: providerId, email }
    ).pipe(
      map((response: Response) => {
        if (response['result'] && response['result']['token']) {
          localStorage.setItem('access_token', response['result']['token']);
          setForcePasswordChangeFlag(!!response['result']['forcepasswordchange']);
        }
        return response;
      })
    ).toPromise();

    if (response && response['result'] && response['result']['token']) {
      try {
        await this._csrfService.fetchCsrfToken();
      } catch (error) {
        console.error('Failed to fetch CSRF token:', error);
      }
    }

    return response;
  }

  logout() {
    localStorage.removeItem('access_token');
    localStorage.clear();
    localStorage.removeItem(CLAVE_CARA_GUARDADA);
    sessionStorage.removeItem(CLAVE_CARA_SESION);
    this._cookieService.deleteAll('/', `.${location.hostname}`);
    this._csrfService.clearToken();
  }

  loggedIn() {
		const token: string | null = this._jwtHelperService.tokenGetter() as string | null;
    if (!token) {
      return false;
    }
    return !this._jwtHelperService.isTokenExpired(token);
  }

  getListPermissions():Promise<any> {
    return this._http.get(`${environment.apiUrl}/common/auth/listpermissions`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    }).toPromise();
  }

}
